export default "__VITE_ASSET__COCYk6lP__"